import { t } from 'i18next';

/**
 * spots_category key에 따라 title/description locale을 반환
 * @param key spots_category (예: 'birthday_cafe', 'exhibition' 등)
 * @returns { title: string, description: string }
 */
export function getSpotsCategoryLocaleValue(key: string): string {
  return t(`SpotsCategory.${key}.value`, { defaultValue: '' });
}
